// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map[data-v-b808d078]{height:400px;width:100%;position:relative;top:0;left:0}", ""]);
// Exports
module.exports = exports;
